<template>
  <section class="bg-gray-500 py-8 px-4 lg:px-12 lg xl:py-12 2xl:py-16">
    <div class="flex flex-col items-center">
      <div class="mt-6 lg:mt-10 xl:mt-12">
        <a
          href="https://opensea.io/collection/lazy-lions"
          target="_blank"
          rel="noreferrer"
          class="block bg-blue-400 py-3 px-12 rounded-3xl shadow-md lg:px-16 text-3xl font-serif text-white md:mt-0 xl:px-20 xl:py-4 xl:text-4xl Home_button__Xc9mA"
        >
          View On OpenSea
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Section5",
};
</script>